// Mock data for Purposefully Covered Insurance Group

export const testimonials = [
  {
    id: 1,
    name: "Robert Thompson",
    role: "Retired Teacher",
    location: "Savannah, GA",
    category: "Final Expense",
    image: "https://static.prod-images.emergentagent.com/jobs/f62ea3e4-bec8-4ef3-9597-f2f1df1dea1e/images/18dec18110be1f9a2493e7332b2fb29f45ace9c5da77d2062b66e4f8156cfefb.png",
    rating: 5,
    text: "David took the time to explain my final expense options in a way I could understand. I never felt rushed or pressured. Purposefully Covered Insurance Group helped me feel confident about protecting my family."
  },
  {
    id: 2,
    name: "Dorothy Jenkins",
    role: "Retired Nurse",
    location: "Savannah, GA",
    category: "Medicare",
    image: "https://static.prod-images.emergentagent.com/jobs/f62ea3e4-bec8-4ef3-9597-f2f1df1dea1e/images/c0d0e81fa4ae9442cfee87e09391fa998de7fc111364035edcc8326611d154a1.png",
    rating: 5,
    text: "I was confused about Medicare options until I spoke with Purposefully Covered Insurance Group. They answered all my questions and helped me find coverage that fits my budget. I finally feel like I made the right choice."
  },
  {
    id: 3,
    name: "James Mitchell",
    role: "Small Business Owner",
    location: "Macon, GA",
    category: "Life Insurance",
    image: "https://randomuser.me/api/portraits/men/67.jpg",
    rating: 5,
    text: "Purposefully Covered Insurance Group helped me secure life insurance for my family and my business. David was professional, knowledgeable, and genuinely cared about getting me the right coverage. Outstanding service!"
  },
  {
    id: 4,
    name: "Linda Washington",
    role: "Retired Postal Worker",
    location: "Augusta, GA",
    category: "Final Expense",
    image: "https://randomuser.me/api/portraits/women/58.jpg",
    rating: 5,
    text: "The team at Purposefully Covered Insurance Group was patient and kind, never pushy. They helped me understand my options and I got coverage I can afford. My children don't have to worry about funeral expenses now."
  },
  {
    id: 5,
    name: "Charles Davis",
    role: "Veteran",
    location: "Columbus, GA",
    category: "Medicare",
    image: "https://randomuser.me/api/portraits/men/71.jpg",
    rating: 5,
    text: "As a veteran, I needed supplemental coverage that worked with my VA benefits. David at Purposefully Covered Insurance Group took the time to find the right solution. I couldn't be happier with the personal attention I received."
  },
  {
    id: 6,
    name: "Patricia Brown",
    role: "Retired Homemaker",
    location: "Athens, GA",
    category: "Life Insurance",
    image: "https://static.prod-images.emergentagent.com/jobs/f62ea3e4-bec8-4ef3-9597-f2f1df1dea1e/images/3368c84199b0a442c2fc579e20ffdb64f3d307ac0ce0ed645c11b778d6dcfcc7.png",
    rating: 5,
    text: "I called Purposefully Covered Insurance Group for information about life insurance and ended up with a policy that gives my family real protection. David made everything so easy to understand. Truly grateful."
  },
  {
    id: 7,
    name: "Marcus Williams",
    role: "Warehouse Manager",
    location: "Savannah, GA",
    category: "Health Insurance",
    image: "https://randomuser.me/api/portraits/men/52.jpg",
    rating: 5,
    text: "I lost my employer coverage and didn't know where to turn. Purposefully Covered Insurance Group walked me through ACA Marketplace options and found a plan that covered my whole family at a price I could manage."
  },
  {
    id: 8,
    name: "Keisha Robinson",
    role: "Freelance Designer",
    location: "Atlanta, GA",
    category: "Health Insurance",
    image: "https://static.prod-images.emergentagent.com/jobs/f62ea3e4-bec8-4ef3-9597-f2f1df1dea1e/images/57386d71b48a1b49744f682abac89c6368581f82a652d262beecd1a7525189d1.png",
    rating: 5,
    text: "As a self-employed professional, finding affordable health insurance felt impossible. Purposefully Covered Insurance Group helped me navigate the ACA plans and I qualified for a subsidy I didn't even know about. Highly recommend!"
  }
];

export const insuranceTypes = [
  {
    id: 1,
    title: "Life Insurance",
    description: "Term and whole life insurance solutions to protect your family's financial future, replace lost income, and provide long-term security.",
    icon: "shield",
    link: "/life-insurance"
  },
  {
    id: 2,
    title: "Final Expense Insurance",
    description: "Affordable whole life coverage designed for ages 50-85 to help cover funeral costs and final expenses, ensuring your loved ones aren't burdened.",
    icon: "umbrella",
    link: "/final-expense"
  },
  {
    id: 3,
    title: "Health & Supplemental",
    description: "ACA Marketplace plans, hospital indemnity, accident, critical illness, and supplemental coverage to fill gaps in your health protection.",
    icon: "plus",
    link: "/health-supplemental"
  },
  {
    id: 4,
    title: "Medicare",
    description: "Medicare Advantage, Medicare Supplement, and prescription drug coverage options to help you navigate your Medicare benefits.",
    icon: "heart",
    link: "/medicare"
  },
  {
    id: 5,
    title: "IULs",
    description: "Indexed Universal Life insurance for life protection with potential cash value growth based on market index performance.",
    icon: "trending",
    link: "/iuls"
  },
  {
    id: 6,
    title: "Annuities",
    description: "Fixed and indexed annuity options for retirement income planning, financial confidence, and legacy protection.",
    icon: "landmark",
    link: "/annuities"
  },
  {
    id: 7,
    title: "Dental",
    description: "Dental coverage for preventive care, basic and major services, and family dental options to protect your smile and budget.",
    icon: "smile",
    link: "/dental"
  },
  {
    id: 8,
    title: "Vision",
    description: "Vision coverage for eye exams, glasses, contacts, and comprehensive eye care for individuals and families.",
    icon: "eye",
    link: "/vision"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is final expense insurance and who needs it?",
    answer: "Final expense insurance is a type of whole life insurance designed to cover end-of-life expenses such as funeral costs, burial, cremation, medical bills, and outstanding debts. It's ideal for individuals ages 50-85 who want to ensure their family isn't financially burdened when they pass away. Coverage amounts typically range from $5,000 to $35,000 and premiums remain fixed for life."
  },
  {
    id: 2,
    question: "Do I need a medical exam to qualify?",
    answer: "Most final expense policies do not require a medical exam. Instead, you'll answer a few simple health questions during the application process. Some plans offer guaranteed acceptance with no health questions at all, though benefits may be limited in the first two years. This makes it easier for seniors with health conditions to obtain coverage."
  },
  {
    id: 3,
    question: "How much does final expense insurance cost?",
    answer: "Costs vary based on your age, health, gender, tobacco use, and coverage amount. On average, premiums range from $30 to $150 per month. For example, a healthy 60-year-old might pay around $50-$70/month for $10,000 in coverage. We'll provide personalized quotes from multiple carriers to find the most affordable option for your situation."
  },
  {
    id: 4,
    question: "What's the difference between Medicare Advantage and Medicare Supplement?",
    answer: "Medicare Advantage (Part C) is an all-in-one alternative to Original Medicare offered by private insurers, often including prescription drug coverage and extra benefits like dental and vision. Medicare Supplement (Medigap) works alongside Original Medicare to cover out-of-pocket costs like copays and deductibles. We can help you determine which option best fits your healthcare needs and budget."
  },
  {
    id: 5,
    question: "Can I change my coverage amount later?",
    answer: "Yes. With most life insurance and final expense policies, you can increase your coverage amount. Keep in mind that increasing your coverage will also increase your monthly premium, and an increase may require answering a few health questions or going through underwriting again depending on the carrier. You can typically decrease your coverage as well if your needs change. We'll help you review your options and choose the right amount for your situation."
  },
  {
    id: 6,
    question: "How do I know if I qualify for subsidies on ACA plans?",
    answer: "Subsidies (premium tax credits) for ACA Marketplace plans are based on your household income and size. Generally, individuals earning between 100% and 400% of the federal poverty level qualify for assistance. During open enrollment or a special enrollment period, we'll help you determine your eligibility and find the most cost-effective plan available."
  },
  {
    id: 7,
    question: "What happens if I miss a premium payment?",
    answer: "Most policies have a grace period (typically 30-31 days) during which you can make a late payment without losing coverage. If payment isn't received by the end of the grace period, your policy may lapse. Some carriers offer reinstatement options within a certain timeframe. We recommend setting up automatic payments to avoid missed premiums and maintain continuous coverage."
  },
  {
    id: 8,
    question: "How quickly can my coverage start?",
    answer: "For final expense and life insurance, coverage typically begins within 24-48 hours after your application is approved and your first premium is paid. Medicare Advantage and ACA plans have specific effective dates based on enrollment periods and submission timing. We'll guide you through the timeline and ensure you understand when your coverage becomes active."
  }
];

export const agentBenefits = [
  {
    id: 1,
    title: "Comprehensive Training",
    description: "From licensing support to advanced sales techniques, we provide the training and mentorship you need to succeed in the insurance industry.",
    icon: "book"
  },
  {
    id: 2,
    title: "Lead Support",
    description: "Access to quality leads and proven prospecting methods to help you build your client base and grow your business consistently.",
    icon: "users"
  },
  {
    id: 3,
    title: "Tools & Resources",
    description: "Agent portal with weekly activity tracking, sales resources, scripts, presentations, and ongoing support to help you manage and scale your business.",
    icon: "briefcase"
  },
  {
    id: 4,
    title: "Growth Opportunities",
    description: "Build your own team and earn overrides. Leadership development program for those who want to grow beyond personal production.",
    icon: "trending-up"
  }
];

export const companyInfo = {
  name: "Purposefully Covered Insurance Group LLC",
  phone: "(912) 376-9006",
  phoneRaw: "9123769006",
  email: "info@purposefullycoveredgroup.com",
  address: "6205 Abercorn Street, STE 206, Savannah, Georgia 31405",
  city: "Savannah, Georgia",
  hours: "Monday - Friday: 9am - 6pm EST",
  socialMedia: {
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    linkedin: "https://linkedin.com",
    instagram: "https://instagram.com"
  }
};

export const coverageInterestOptions = [
  "Life Insurance",
  "Final Expense",
  "Health & Supplemental",
  "Medicare",
  "IUL",
  "Annuity",
  "Dental",
  "Vision",
  "Not Sure / Need Guidance"
];

export const contactTimeOptions = [
  "Morning",
  "Afternoon",
  "Evening"
];
